module.exports = __webpack_public_path__ + "img/proses_pup.f905adff.svg";